import { Form } from 'antd';
import { InputProps } from 'antd/lib/input';
import * as React from 'react';
import { touch, WrappedFieldProps } from 'redux-form';
import { DatePicker } from 'antd';
import { DatePickerProps } from 'antd/lib/date-picker';
import { FormItemProps } from 'antd/lib/form';
import { isNumber } from 'lodash';
import moment from 'moment';

interface OwnProps extends InputProps {
  pickerStyle?: any;
  minYear?: number;
  maxYear?: number;
}

type FormYearPickerInputProps = WrappedFieldProps & FormItemProps & DatePickerProps & OwnProps;

export const FormYearPickerInput = ({
  label,
  required,
  validateStatus,
  labelCol,
  wrapperCol,
  meta,
  input,
  pickerStyle,
  minYear,
  maxYear,
  placeholder,
  ...rest
}: FormYearPickerInputProps) => {
  const errorMessage = !!meta && meta.error;
  const showError = !!meta && meta.touched && !!meta.error;
  const { value, onBlur, onChange, ...restInput } = input;

  const handleChange: DatePickerProps['onChange'] = (e) => {
    const newValue = e?.get('year');
    onChange(newValue);
  };

  const handleBlur: DatePickerProps['onBlur'] = (e) => {
    meta.dispatch(touch(meta.form, input.name));
  };

  const yearValue = value && isNumber(value) ? moment({ year: value }) : undefined;

  return (
    <Form.Item
      label={label}
      required={required}
      validateStatus={showError ? 'error' : undefined}
      help={showError ? errorMessage : undefined}
      {...rest}
    >
      <DatePicker
        style={pickerStyle}
        value={yearValue}
        picker="year"
        format="YYYY"
        onChange={handleChange}
        onBlur={handleBlur}
        disabledDate={(d) =>
          !d || (!!minYear && d.get('year') < minYear) || (!!maxYear && d.get('year') > maxYear)
        }
        placeholder={placeholder}
        {...restInput}
      />
    </Form.Item>
  );
};
